export const FETCH_FASTAG_CONFIG_SUCCESS = 'FETCH_FASTAG_CONFIG_SUCCESS';
